// Selectors
import { ApplicationState } from '../../store';


export const impactTypeSelector = (state: ApplicationState) => state.impactTypeState


